import type { AppStrings } from './types.js';
import { plural } from './plural.js';

export const ar: AppStrings = {
  // COMMON
  error_title: 'خطأ',
  cancel: 'إلغاء',
  retry: 'إعادة المحاولة',
  back_arrow: '← رجوع',

  // ASK SCREEN
  ask_box_unavailable: 'الصندوق غير متاح',
  ask_box_unavailable_desc: 'قد يكون الرابط قديمًا أو أغلق المالك صندوقه.',
  ask_create_own_box: 'أنشئ صندوقك الخاص',
  ask_sent_title: 'تم الإرسال ✅',
  ask_sent_desc: 'وصل سؤالك المجهول إلى صاحب الصندوق.',
  ask_anonymous_hint: 'سيُرسَل سؤالك بشكل مجهول.',
  ask_placeholder: 'اكتب سؤالك…',
  ask_send: 'إرسال',
  ask_sending: 'جارٍ الإرسال…',
  ask_error_rate_limit: 'طلبات كثيرة جدًا — انتظر دقيقة.',
  ask_error_restart: 'أعد تشغيل Mini App.',
  ask_error_load: 'تعذّر تحميل الصندوق.',
  ask_error_send: 'تعذّر إرسال السؤال.',
  ask_error_banned: 'أنت محظور في التطبيق.',
  ask_banned_appeal_btn: 'تظلّم',
  ask_appeal_sent: 'تم إرسال التظلّم. سنراجعه يدويًا.',

  // AGE GATE
  age_gate_title: '+18 فقط',
  age_gate_desc:
    'أنت ترسل سؤالًا مجهولًا. كن محترمًا: التحرش والتهديدات والمحتوى الجنسي الذي يشمل القاصرين وأي محتوى يخالف القانون ممنوع. المجهولية لا تعني الإفلات من العقوبة — تُبلَّغ الانتهاكات إلى قسم الإشراف. بإرسال السؤال، تؤكد أن عمرك +18 وتقبل القواعد.',
  age_gate_confirm: 'عمري +18 — متابعة',

  // INBOX SCREEN
  inbox_title: 'صندوقك',
  box_link_accordion: 'رابط الدعوة',
  inbox_notifications_ask: '🔔 هل تسمح للبوت بإرسال إشعارات عن الأسئلة الجديدة؟',
  inbox_notifications_allow: 'سماح',
  inbox_notifications_dismiss_label: 'تجاهل',
  inbox_box_toggle_disable: 'تعطيل الأسئلة',
  inbox_box_toggle_enable: 'تفعيل الأسئلة',
  inbox_box_disabled_warning: 'الأسئلة معطّلة — لن تُقبَل أسئلة جديدة.',
  inbox_share_hint: 'شارك الرابط حتى يتمكن أصدقاؤك من طرح أسئلة مجهولة عليك.',
  inbox_copy: 'نسخ',
  inbox_copied: 'تم النسخ',
  inbox_copy_error: 'خطأ',
  inbox_no_deeplink: 'سيظهر الرابط بعد النشر.',
  inbox_invite_story: 'دعوة عبر Story',
  inbox_invite_chat: 'دعوة عبر المحادثة',
  inbox_card_rendering: 'بطاقة الدعوة لا تزال تُعالَج.',
  inbox_story_unsupported:
    'القصص غير متاحة في هذا الإصدار من Telegram. جرّب "عبر المحادثة".',
  inbox_story_error: 'تعذّر فتح Story.',
  inbox_chat_unsupported:
    'المشاركة عبر المحادثة غير متاحة في هذا الإصدار من Telegram. حدّث التطبيق.',
  inbox_chat_error: 'تعذّرت المشاركة. حاول مجددًا.',
  inbox_chat_prepare_error: 'تعذّر تجهيز الدعوة.',
  inbox_filter_incoming: 'الوارد',
  inbox_filter_hidden: 'المخفية',
  inbox_filter_blocked: 'المحظورة',
  inbox_filter_empty: 'لا شيء هنا بعد.',
  inbox_acc_unanswered: 'غير مُجاب',
  inbox_acc_answered: 'مُجاب',
  inbox_acc_hidden: 'مخفي',
  inbox_acc_blocked: 'محظور',
  inbox_empty: 'لا أسئلة بعد. شارك الرابط أعلاه.',
  inbox_load_more: 'تحميل المزيد',
  inbox_load_more_error: 'تعذّر تحميل الصفحة التالية.',
  inbox_error_load: 'تعذّر تحميل الصندوق.',
  inbox_rate_limit: 'طلبات كثيرة جدًا — انتظر دقيقة.',
  inbox_toggle_error: 'تعذّر تغيير حالة الصندوق.',

  // MESSAGE BOX (Трек D)
  message_tagline: 'اكتب لي بشكل مجهول',
  message_placeholder: 'اكتب رسالة…',
  message_anonymous_hint: 'ستُرسَل رسالتك بشكل مجهول.',
  message_sent_title: 'تم الإرسال ✅',
  message_sent_desc: 'وصلت رسالتك المجهولة.',
  message_owner_entry: 'اكتب لي',
  message_share_hint: 'شارك الرابط حتى يتمكن أي شخص من إرسال رسالة مجهولة لك.',
  message_inbox_open: 'الرسائل المستلمة',
  message_inbox_title: 'الرسائل',
  message_inbox_empty: 'لا رسائل بعد. شارك رابطك أعلاه.',

  // ANSWER SCREEN
  answer_title: 'أجب على السؤال',
  answer_placeholder: 'اكتب إجابتك…',
  answer_submit: 'إرسال',
  answer_submitting: 'جارٍ الإرسال…',
  answer_back: 'رجوع',
  answer_error_send: 'تعذّر إرسال الإجابة.',

  // SHARE SCREEN
  share_title: 'نُشرت الإجابة ✅',
  share_hint: 'شارك البطاقة واجمع المزيد من الأسئلة.',
  share_card_rendering_desc:
    'البطاقة لا تزال تُعالَج. ارجع إلى الأسئلة وتحقق بعد قليل — ستتمكن من مشاركتها في Story أو محادثة.',
  share_card_alt: 'بطاقة الإجابة',
  share_story_btn: 'مشاركة في Story',
  share_story_btn_busy: 'جارٍ الفتح…',
  share_chat_btn: 'مشاركة في المحادثة',
  share_chat_btn_busy: 'جارٍ التجهيز…',
  share_back: 'العودة إلى الأسئلة',
  share_story_unsupported:
    'القصص غير متاحة في هذا الإصدار من Telegram. جرّب "مشاركة في المحادثة".',
  share_story_error: 'تعذّر فتح Story. جرّب "مشاركة في المحادثة".',
  share_chat_sent: 'تم إرسال الرسالة.',
  share_chat_unsupported:
    'المشاركة عبر المحادثة غير متاحة في هذا الإصدار من Telegram. حدّث التطبيق.',
  share_chat_error: 'تعذّرت المشاركة. حاول مجددًا.',
  share_chat_prepare_error: 'تعذّر تجهيز الرسالة.',

  // LEADERBOARD SCREEN
  lb_title: 'لوحة المتصدرين',
  lb_period_7d: '7 أيام',
  lb_period_30d: '30 يومًا',
  lb_period_all: 'كل الوقت',
  lb_group_label: 'الفئة',
  lb_group_all: 'الكل',
  lb_group_ask: 'اسأل',
  lb_group_rate: 'قيّم',
  lb_group_confession: 'اعتراف',
  lb_group_guesswho: 'خمّن من',
  lb_group_message: 'الرسائل',
  lb_error: 'تعذّر تحميل لوحة المتصدرين',
  lb_empty: 'لا أحد في الترتيب بعد',
  lb_anon: 'مجهول',
  lb_load_more: 'تحميل المزيد',
  lb_questions: (n) =>
    plural('ar', n, {
      zero: 'لا أسئلة',
      one: 'سؤال واحد',
      two: 'سؤالان',
      few: '{n} أسئلة',
      many: '{n} سؤالًا',
      other: '{n} سؤال',
    }),
  lb_referrals: (n) =>
    plural('ar', n, {
      zero: 'لا إحالات',
      one: 'إحالة واحدة',
      two: 'إحالتان',
      few: '{n} إحالات',
      many: '{n} إحالةً',
      other: '{n} إحالة',
    }),

  // REWARDS SCREEN
  rw_title: 'مكافآتي',
  rw_error: 'تعذّر تحميل المكافآت',
  rw_level: (n) => `المستوى ${n}`,
  rw_confirmed_referrals: (n) =>
    plural('ar', n, {
      zero: 'لا إحالات مؤكدة',
      one: 'إحالة مؤكدة واحدة',
      two: 'إحالتان مؤكدتان',
      few: '{n} إحالات مؤكدة',
      many: '{n} إحالةً مؤكدةً',
      other: '{n} إحالة مؤكدة',
    }),
  rw_next_level_section: (n) =>
    plural('ar', n, {
      zero: 'المستوى التالي — لا إحالات',
      one: 'المستوى التالي — إحالة واحدة',
      two: 'المستوى التالي — إحالتان',
      few: 'المستوى التالي — {n} إحالات',
      many: 'المستوى التالي — {n} إحالةً',
      other: 'المستوى التالي — {n} إحالة',
    }),
  rw_to_level: (level, target) => `إلى المستوى ${level}: ${target}`,
  rw_max_level: 'وصلت إلى أعلى مستوى!',
  rw_badges_section: 'الشارات',
  rw_formats_section: 'تنسيقات الصندوق',

  // QUESTION CARD
  qcard_status_new: 'جديد',
  qcard_status_hidden: 'مخفي',
  qcard_status_answered: 'مُجاب',
  qcard_moderation_flagged: 'تحذير: رسالة مريبة',
  qcard_answer_btn: 'أجب',
  qcard_answer_send: 'إرسال',
  qcard_share_btn: 'مشاركة',
  qcard_hide_btn: 'إخفاء',
  qcard_show_btn: 'إظهار',
  qcard_report_btn: 'إبلاغ',
  qcard_block_btn: 'حظر',
  qcard_unblock_btn: 'إلغاء الحظر',
  qcard_report_reason_label: 'اختر سبب الإبلاغ:',
  qcard_reason_spam: 'بريد مزعج',
  qcard_reason_harassment: 'تحرش',
  qcard_reason_sexual: 'محتوى جنسي',
  qcard_reason_other: 'أخرى',
  qcard_error_hide: 'تعذّر تغيير حالة الظهور.',
  qcard_error_report: 'تعذّر إرسال البلاغ.',
  qcard_error_block: 'تعذّر حظر المُرسِل.',
  qcard_report_done: 'تم إرسال البلاغ — شكرًا.',
  qcard_block_done: 'تم حظر المُرسِل.',
  qcard_unblock_done: 'تم إلغاء حظر المُرسِل.',

  // ERRORS
  err_network: 'لا اتصال بالخادم. تحقق من الإنترنت وحاول مجددًا.',
  err_server_unavailable: 'الخادم غير متاح مؤقتًا، حاول مجددًا لاحقًا.',
  err_internal: 'حدث خطأ من طرفنا. نحن نعمل على حله — حاول مجددًا لاحقًا.',
  err_bad_request: 'يرجى التحقق من البيانات التي أدخلتها.',
  err_generic: 'تعذّر إتمام الإجراء، حاول مجددًا لاحقًا.',
  err_schema: 'خطأ في البيانات. جرّب تحديث التطبيق.',
  share_story_link_premium_note:
    'رابط قابل للنقر في القصص يتطلب Telegram Premium. بدونه لا يزال بإمكان أصدقائك إيجادك — اسمك موجود على البطاقة.',

  // AUTH ERROR SCREEN
  auth_error_title: 'خطأ في الوصول',
  auth_error_desc:
    'تعذّرت المصادقة. أغلق Mini App وأعد فتحه من Telegram.',

  // REWARD TOAST
  reward_toast_title: 'مكافأة جديدة!',
  reward_toast_close: '×',

  // BOTTOM TABBAR
  tab_questions: 'الأسئلة',
  tab_leaderboard: 'المتصدرون',
  tab_rewards: 'المكافآت',
  tab_settings: 'الإعدادات',

  // SETTINGS SCREEN
  settings_title: 'الإعدادات',
  settings_section_general: 'عام',
  settings_notifications: 'إشعارات الأسئلة الجديدة',
  settings_notifications_hint: 'سيرسل البوت لك رسالة عندما يطرح أحدهم سؤالًا.',
  settings_notifications_error: 'تعذّر حفظ إعداد الإشعارات.',
  settings_language: 'اللغة',
  settings_language_error: 'تعذّر تغيير اللغة. حاول مجددًا.',
  settings_section_about: 'حول',
  settings_version: 'الإصدار',

  // CODE ENTRY
  code_modal_title: 'روابط القصص متاحة لـ Premium فقط',
  code_modal_explain:
    'Telegram يمنح رابطًا قابلًا للنقر في القصص لمشتركي Premium فقط. بدلًا من ذلك أضف كودك في القصة — يكتبه الزوار في التطبيق ويطرحون عليك سؤالًا مجهولًا.',
  code_modal_your_code: 'كودك',
  code_modal_copy: 'نسخ الكود',
  code_modal_copied: 'تم النسخ',
  code_modal_share_btn: 'مشاركة في القصة',
  code_modal_loading: 'جارٍ الحصول على كودك…',
  code_modal_error: 'تعذّر الحصول على كودك. حاول مجددًا لاحقًا.',
  ask_code_title: 'أدخل الكود',
  ask_code_desc:
    'أتيت من قصة؟ ابحث عن الكود فيها (مثلًا 1234) واكتبه أدناه.',
  ask_code_placeholder: 'الكود من القصة',
  ask_code_find: 'بحث',
  ask_code_not_found: 'الكود غير موجود. تحقق من الأرقام وحاول مجددًا.',
  ask_code_invalid: 'الكود مكوّن من 4 أرقام.',
  code_onboarding_header: 'أتيت من قصة؟',
  code_onboarding_text: 'أدخل كود صديقك لتطرح عليه سؤالًا مجهولًا.',
  code_onboarding_action: 'أدخل الكود',
  settings_ask_by_code: 'اسأل بالكود',
  settings_my_code_title: 'كود قصتك',
  settings_my_code_hint:
    'اكتب هذا الكود في قصتك — يكتبه الزوار لطرح أسئلة مجهولة عليك. Telegram يمنح روابط القصص القابلة للنقر لمشتركي Premium فقط.',
  settings_my_code_rotate: 'الحصول على كود جديد',
  settings_my_code_rotating: 'جارٍ التحديث…',
  settings_my_code_done: 'تم تحديث الكود',
  settings_my_code_error: 'تعذّر الحصول على كودك.',
  settings_my_code_rotate_confirm_title: 'تغيير الكود؟',
  settings_my_code_rotate_confirm_desc:
    'يتوقّف كودك القديم عن العمل فورًا، ولن يتمكّن أيّ شخص رآه في قصتك من الوصول إليك. لا تغيّره إلا إذا كان أحدهم يزعجك بالرسائل المتكرّرة.',
  settings_my_code_rotate_confirm_action: 'تغيير الكود',

  // BOT
  bot_greeting: (name) => (name ? `أهلاً، ${name}! 👋` : 'أهلاً! 👋'),
  bot_onboarding:
    'هذا هو VeylMe — الأسئلة المجهولة.\n\n' +
    'افتح Mini App، انشر بطاقة «اسألني بشكل مجهول» في قصتك — ' +
    'واستقبل الأسئلة المجهولة هنا مباشرةً.\n\n' +
    '⚠️ 18+. كن محترمًا: التنمر والتهديدات والمحتوى المحظور ' +
    'غير مسموح به. الهوية المجهولة ≠ الإفلات من العقاب — المخالفات تُحال إلى الإشراف.',
  bot_open_btn: 'فتح VeylMe',
  notify_answer_btn: 'أجب',
  bot_invite_text:
    'شارك أحدهم رابط VeylMe.\n\n' +
    'افتح Mini App لطرح سؤال مجهول:',
  bot_invite_btn: 'اسأل بشكل مجهول',

  // WORK-027 i18n sweep
  tagline: 'اسألني بشكل مجهول',
  share_ask_action: 'اسأل',
  share_answered_text: 'أجبت عن سؤال مجهول 👀',
  err_not_in_telegram: 'Mini App لا يعمل داخل Telegram. يرجى إعادة تشغيل التطبيق.',
  badge_viral_starter: 'بداية فيروسية',
  badge_storyteller: 'راوي القصص',
  badge_loop_master: 'سيد الحلقة',
  theme_confession: 'اعترافات',
  theme_guesswho: 'خمّن من',
  rw_format_named: (name) => `تنسيق «${name}»`,
  card_label_question: 'سؤال',
  card_label_answer: 'إجابة',
  card_invite_subtitle: 'مجهول، بدون تسجيل',
  card_code_hint: 'أدخل الكود في التطبيق',
  share_msg_title: (brand) => `${brand} · أسئلة مجهولة`,
  notify_new_question: '🔔 وصلك سؤال مجهول',
  notify_unanswered_reminder: (n) =>
    plural('ar', n, {
      zero: '🔔 ليس لديك أسئلة بلا إجابة',
      one: '🔔 لديك سؤال واحد بلا إجابة',
      two: '🔔 لديك سؤالان بلا إجابة',
      few: '🔔 لديك {n} أسئلة بلا إجابة',
      many: '🔔 لديك {n} سؤالًا بلا إجابة',
      other: '🔔 لديك {n} سؤال بلا إجابة',
    }),
  notify_ban_permanent: 'بشكل دائم',
  notify_ban_until: (date) => `حتى ${date}`,
  notify_ban_msg: (untilPhrase) =>
    `⛔ تم حظرك في VeylMe ${untilPhrase}. أبلغ عدد كبير جدًا من المستلمين عن رسائلك.\nإذا كنت تعتقد أن هذا خطأ، يمكنك تقديم استئناف في التطبيق.`,
  notify_warning_msg:
    '⚠️ أبلغ عدة مستلمين عن رسائلك. القليل بعد وسيتم حظرك في VeylMe.',

  // MY QUESTIONS SCREEN + InvitePanel non-premium hint (retention-answer-loop)
  my_questions_title: 'أسئلتي',
  my_questions_empty_title: 'لم تطرح أي سؤال بعد',
  my_questions_empty_desc: 'اطرح سؤالاً في صندوق أحدهم — سيظهر الرد هنا.',
  my_questions_loading: 'نتحقق من وجود رد…',
  my_questions_waiting: 'بانتظار الرد',
  my_questions_answer_label: 'الرد',
  settings_my_questions: 'أسئلتي',
  ask_sent_find_reply_hint: 'يمكنك إيجاد الرد لاحقاً في «أسئلتي».',
  inbox_story_nonpremium_hint: 'رابط القصة غير قابل للنقر بدون Telegram Premium، لذا نعرض رمزاً بدلاً منه — المشاركة في محادثة أكثر موثوقية.',

  // SESSION EXPIRY SCREEN (work-038)
  session_expired_title: 'انتهت صلاحية تصريح Telegram',
  session_expired_desc: 'يمنح Telegram التطبيق تصريحاً مرة واحدة فقط عند التشغيل، وهذا التصريح انتهت صلاحيته. افتح التطبيق من جديد — النص الذي بدأته حفظناه لك.',
  session_expired_desc_no_storage: 'انتهت صلاحية تصريح Telegram ويجب إعادة فتح التطبيق. لم نستطع حفظ النص الذي كتبته — انسخه قبل المغادرة.',
  session_expired_reopen: 'فتح من جديد',
  session_expired_stuck_title: 'أعاد Telegram التصريح القديم نفسه',
  session_expired_stuck_desc: 'أغلق التطبيق تماماً من قائمة البوت ثم افتحه من جديد — عندها يمنحك Telegram تصريحاً جديداً.',
  session_auth_failed_title: 'تعذّر تأكيد الدخول',
  session_auth_failed_desc: 'لم يؤكّد Telegram دخولك إلى التطبيق. أغلق التطبيق وافتحه من جديد من المحادثة مع البوت.',
  session_expired_manual_close: 'لا يستطيع التطبيق إغلاق نفسه من هنا — أغلقه بنفسك وافتحه من جديد من المحادثة مع البوت.',
  session_expiring_soon: 'ستنتهي صلاحية تصريح Telegram قريباً. افتح التطبيق من جديد كي لا تفقد شيئاً.',
  my_questions_check_failed: 'تعذّر التحقق من الردود. حاول لاحقاً.',
  settings_notifications_load_error: 'تعذّر تحميل الإعداد.',
};
